import React from 'react';
import AgentForm from '../components/AgentForm';

const AgentCreation = () => {
  return (
    <div>
      <div className="header">
        <h1>Create Voice Agent</h1>
      </div>
      
      <div className="card">
        <AgentForm />
      </div>
    </div>
  );
};

export default AgentCreation;
